import { useState, useEffect } from 'react';

import { useIsClient } from './useIsClient';

const useWindowSize = () => {
  const isClient = useIsClient();
  const [width, setWidth] = useState<number>(isClient ? window.innerWidth : 0);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    if (isClient) {
      window.addEventListener('resize', handleResize);
      handleResize();
    }

    return () => {
      if (isClient) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [isClient]);

  return width;
};

export default useWindowSize;
